import React, { useState } from 'react';
import IngestedBatchesList from './components/IngestedBatchesList';
import ActionBar from '../layout/ActionBar';
import RemoveIngestedKeys from './slideout/RemoveIngestedKeys';
import SlidingPane from 'react-sliding-pane';
import { retryIngestedKeys } from '../../actions/keyCodeActions';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';

function IngestedBatches() {
  usePageTitle(['Ingested batches', 'Keys']);
  const [reload, setReload] = useState<any>();
  const { t } = useTranslation();

  const [removeIngestedSlideoutOpen, setRemoveIngestedSlideoutOpen] =
    useState(false);
  const [removeIngestedSlideoutItem, setRemoveIngestedSlideoutItem] =
    useState<any>();
  const [breadcrumb, setBreadcrumb] = useState<{ label: string; link: string }[]>([
    { label: t('Ingested batches'), link: '/keys/ingested-batches' },
  ]);
  const onRetry = (e: any, item: any) => {
    retryIngestedKeys(item.id)
      .then(() => {
        toast.success(t('Retrying batch'));
        setReload(new Date());
      })
      .catch((err: Error) => toast.error(err.message || t('Failed to retry')));
  };

  return (
    <>
      <ActionBar breadcrumb={breadcrumb} />

      <IngestedBatchesList
        reload={reload}
        onRemove={(e: any, transaction: any) => {
          setRemoveIngestedSlideoutItem(transaction);
          setRemoveIngestedSlideoutOpen(true);
        }}
        onRetry={onRetry}
        setBreadcrumb={setBreadcrumb}
      />

      <SlidingPane
        isOpen={removeIngestedSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setRemoveIngestedSlideoutOpen(false)}
      >
        {removeIngestedSlideoutItem ? (
          <RemoveIngestedKeys
            id={removeIngestedSlideoutItem.id}
            done={() => {
              setReload(new Date());
              setRemoveIngestedSlideoutOpen(false);
            }}
            cancel={() => setRemoveIngestedSlideoutOpen(false)}
          />
        ) : null}
      </SlidingPane>
    </>
  );
}

export default IngestedBatches;
